/**
 * AI Editor Configuration
 *
 * This is the single source of truth for all AI-related settings.
 * The AI_API_BASE_URL points to your centralized AI API - this is
 * the same across all apps that use this kit.
 */

export const AI_CONFIG = {
  // Your centralized AI API base URL (same for all apps)
  // This is the deployed API that handles all AI requests
  AI_API_BASE_URL: 'https://your-ai-api.supabase.co/functions/v1',

  // Model configuration for the AI API
  MODEL: {
    provider: 1,
    id: 33 // gpt-5.4-mini (latest as of 08/04/2026)
  },

  // Template IDs - these are defined in your centralized AI API
  // Do NOT change these - they must match the API
  TEMPLATES: {
    PROFESSIONAL: 16,
    SUMMARY: 17,
    FRIENDLY: 18,
    CONCISE: 19,
    KEY_POINTS: 20,
    SUGGEST_EDITS: 21,
    PROOF_READ: 22,
    AI_WRITER: 24
  },

  // Local edge function paths (these proxy to AI_API_BASE_URL)
  EDGE_FUNCTIONS: {
    TEXT_COMPLETION: 'addai/text-completion',
    VOICE_COMPLETION: 'addai/voice-completion'
  },

  // File upload limits
  FILE_LIMITS: {
    MAX_PDF_SIZE_MB: 32
  }
};
